import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { money, StatusBadge } from "@/components/admin/AdminLayout";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUSES = ["all", "Payment Pending", "Awaiting Fulfillment", "Supplier Order Created", "Shipped", "Delivered", "Cancelled", "Refunded", "Requires Review"];

export default function Orders() {
  const [params, setParams] = useSearchParams();
  const [orders, setOrders] = useState([]);
  const status = params.get("status") || "all";
  const flagged = params.get("flagged") === "1";

  useEffect(() => {
    const sp = new URLSearchParams();
    if (status !== "all") sp.set("status", status);
    if (flagged) sp.set("flagged", "true");
    api.get(`/admin/orders?${sp.toString()}`).then((r) => setOrders(r.data));
  }, [status, flagged]);

  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <div><h1 className="font-display text-2xl font-bold tracking-tight">Orders</h1><p className="text-sm text-zinc-500">{orders.length} orders{flagged ? " requiring attention" : ""}</p></div>
        <Select value={status} onValueChange={(v) => { const p = new URLSearchParams(params); v === "all" ? p.delete("status") : p.set("status", v); setParams(p); }}>
          <SelectTrigger className="w-56" data-testid="order-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s === "all" ? "All statuses" : s}</SelectItem>)}</SelectContent>
        </Select>
      </div>

      <div className="bg-white border border-zinc-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-zinc-500 bg-zinc-50 border-b border-zinc-200">
            <th className="p-3 font-medium">Order</th><th className="p-3 font-medium">Date</th>
            <th className="p-3 font-medium">Customer</th><th className="p-3 font-medium">Items</th>
            <th className="p-3 font-medium">Total</th><th className="p-3 font-medium">Profit</th>
            <th className="p-3 font-medium">Payment</th><th className="p-3 font-medium">Status</th>
          </tr></thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className={`border-b border-zinc-50 hover:bg-zinc-50/50 ${o.flagged ? "bg-red-50/40" : ""}`}>
                <td className="p-3"><Link to={`/admin/orders/${o.id}`} className="font-mono text-xs font-medium text-blue-600" data-testid={`order-link-${o.order_number}`}>{o.order_number}</Link></td>
                <td className="p-3 text-xs text-zinc-500">{new Date(o.created_at).toLocaleDateString()}</td>
                <td className="p-3 text-zinc-600">{o.shipping_address?.name || o.email}</td>
                <td className="p-3">{o.items.length}</td>
                <td className="p-3 font-medium">{money(o.total)}</td>
                <td className="p-3 text-green-600">{money(o.estimated_profit)}</td>
                <td className="p-3"><StatusBadge status={o.payment_status === "paid" ? "Paid" : "Payment Pending"} /></td>
                <td className="p-3"><StatusBadge status={o.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders.length === 0 && <p className="text-center py-16 text-zinc-400 text-sm">No orders found.</p>}
      </div>
    </div>
  );
}
